import { MutationTree } from "vuex";
import { PointState } from "../types/PointState";

export const mutations: MutationTree<PointState> = {
    setPoints(state, points) {
        state.points = points;
    },
    clearPoints(state) {
        state.points = null;
    },
    setInterval(state, intervalId) {
        state.updateIntervalId = intervalId;
    },
    clearInterval(state) {
        state.updateIntervalId = null;
    }
}
